<div class="page">

    <div class="page-name">Manage Release Dates</div>

    <ng-container *ngIf="loadingData || !interplanDataUi">
        <div class="manage-toolbar d-flex">
            <div class="rounded-pill skeleton skeleton-table-row" style="height: 30px; width: 200px; margin-right: 1rem;"></div>
            <div class="rounded-pill skeleton skeleton-table-row" style="height: 30px; width: 200px; margin-right: 1rem;"></div>
            <div class="rounded-pill skeleton skeleton-table-row" style="height: 30px; width: 200px; margin-right: 1rem;"></div>
        </div>
        <div class="magage-release-sec">
            <div class="skeleton skeleton-table-row" style="height: 50px;"></div>
            <div class="skeleton skeleton-table-row" *ngFor="let i of [0,0,0,0,0,0,0,0,0,0,0]"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="!loadingData && interplanDataUi">

        <div class="manage-toolbar" *ngIf="interplanDataUi.data?.length">
            <dx-button class="rounded-pill manage-btn" type="default" stylingMode="contained" text="Sync Int'l Date"
                [disabled]="(interplanDataUi.synchedIntlData.length==interplanDataUi.data.length) || disManageAdmin"
                (click)="syncDate('INTL')"
            ></dx-button>
            <dx-button class="rounded-pill manage-btn" type="default" stylingMode="contained" text="Sync US Date"
                [disabled]="(interplanDataUi.synchedUsData.length==interplanDataUi.data.length) || disManageAdmin"
                (click)="syncDate('US')"
            ></dx-button>
            <dx-button class="rounded-pill manage-btn" type="default" stylingMode="contained" text="Sync Both Date"
                [disabled]="(interplanDataUi.synchedData.length==interplanDataUi.data.length) || disManageAdmin"
                (click)="syncDate('BOTH')"    
            ></dx-button>
        </div>
    
        <div class="magage-release-sec">

            <div class="new-title-msg-block" *ngIf="showUnviewedDataMsg">
                <div class="msg">There are {{interplanDataUi.data.length}} unsynched titles.</div>
                <dx-button icon="remove" (click)="showUnviewedDataMsg=false" [disabled]="disManageAdmin" stylingMode="contained" type="success"></dx-button>
            </div>
    

            <div class="refresh-btn-block">
                <dx-button icon="refresh" hint="Refresh" (click)="fetchInterplanData(true)"></dx-button>
            </div>

            <div class="magage-release-table-block" id="manageReleaseTable">

                <table class="manage-release-table" >
    
                    <tr class="manage-release-header-row">
                        <th 
                            *ngFor="let h of tableHeaderData" 
                            class="cell header-cell"
                            [ngClass]="h=='Title'?'cell-1': h.includes('Territory')? 'cell-3' : 'cell-2'"
                        >
                            {{h}}
                        </th>
                    </tr>
    
                    <ng-container *ngIf="interplanDataUi.data?.length">
                        <tr class="manage-release-data-row"  *ngFor="let d of interplanDataUi.data; let i = index">
                            <td class="cell cell-1">
                                <div *ngIf="!disManageAdmin" class="psr-title"
                                    routerLink="/{{d.projectId}}/report/post-production/schedule"
                                    style="cursor: pointer;"
                                >{{d.psrTitle}}</div>
                                <div *ngIf="disManageAdmin" class="psr-title"
                                >{{d.psrTitle}}</div>
                                <ng-container *ngIf="d.projectAkas?.length">
                                    <div *ngFor="let a of d.projectAkas">{{a}}</div>
                                </ng-container>
                            </td>
                            <td class="cell cell-2">{{d.psrIntlReleaseDate}}</td>
                            <td class="cell cell-3">{{d.currentTerritory}}</td>
                            <td class="cell cell-2">
                                <div class="sync-dt-block">
                                    <div class="rel-dt">{{d.interplanIntlReleaseDate}}</div>
                                    <dx-button *ngIf="d?.interplanIntlReleaseDate?.toString()?.trim() != ''  && !interplanDataUi.synchedIntlData.includes(d) && !syncIntlInProgressIdList.includes(d.interplanReleaseDatesId)" 
                                        [disabled]="disManageAdmin" icon="pulldown" hint="sync" stylingMode="text" type="normal" class="sync-btn" 
                                        (click)="syncDate('INTL',d)">
                                    </dx-button>
                                    <dx-load-indicator
                                        *ngIf="d?.interplanIntlReleaseDate?.toString()?.trim() != '' && syncIntlInProgressIdList.includes(d.interplanReleaseDatesId) && !interplanDataUi.synchedIntlData.includes(d)"
                                        id="image-indicator"
                                        indicatorSrc="assets/images/common/spinner.gif"
                                    ></dx-load-indicator>
                                    <i *ngIf="d?.interplanIntlReleaseDate?.toString()?.trim() != '' && interplanDataUi.synchedIntlData.includes(d)" class="dx-icon-todo sync-complete-icon"></i>
                                </div>
                            </td>
                            <td class="cell cell-3">{{d.latestTerritory}}</td>
                            <td class="cell cell-2">{{d.psrUSReleaseDate}}</td>
                            <td class="cell cell-2">
                                <div class="sync-dt-block">
                                    <div class="rel-dt">{{d.interplanUSReleaseDate}}</div>
                                    <dx-button 
                                        *ngIf="d?.interplanUSReleaseDate?.toString()?.trim() != '' && !interplanDataUi.synchedUsData.includes(d) && !syncUsInProgressIdList.includes(d.interplanReleaseDatesId)" 
                                        [disabled]="disManageAdmin" icon="pulldown" hint="sync" stylingMode="text" type="normal" class="sync-btn" 
                                        (click)="syncDate('US',d)">
                                    </dx-button>
                                    <dx-load-indicator
                                        *ngIf="d?.interplanUSReleaseDate?.toString()?.trim() != '' && syncUsInProgressIdList.includes(d.interplanReleaseDatesId) && !interplanDataUi.synchedUsData.includes(d)"
                                        id="image-indicator"
                                        indicatorSrc="assets/images/common/spinner.gif"
                                    ></dx-load-indicator>
                                    <i *ngIf="d?.interplanUSReleaseDate?.toString()?.trim() != '' && interplanDataUi.synchedUsData.includes(d)" class="dx-icon-todo sync-complete-icon"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
    
                    <ng-container *ngIf="!interplanDataUi.data?.length">
                        <tr>
                            <td colspan="7">
                                <div class="no-data">No records found!</div>
                            </td>
                        </tr>
                    </ng-container>
                    
                </table>
            </div>
        </div>
    </ng-container>

    <app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>
    

</div>